import { render } from "./ViewAssets.vue?vue&type=template&id=f8045b16"
import script from "./view_assets.js?vue&type=script&lang=js&external"
export * from "./view_assets.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__